import React from 'react'
import PropTypes from 'prop-types'
import styles from '../../styles.scss'

const ProgressBar = (props) => {
    if (props.progress === 0) {
        return null
    }

    const className =
        props.progress === 100 && props.isPlaying
            ? `${styles.launching} ${styles.starting}`
            : styles.launching

    return (
        <div className={className}>
            <p>{props.text}</p>
            <progress max="100" value={props.progress} />
        </div>
    )
}

ProgressBar.propTypes = {
    progress: PropTypes.number,
    text: PropTypes.string,
    isPlaying: PropTypes.bool,
}

export default ProgressBar



// WEBPACK FOOTER //
// ./src/features/LaunchProgressBar/components/ProgressBar/component.js